import gql from 'graphql-tag'

import { UserFieldsFragment } from './user'
import { UserWithFamilyFieldsFragment } from './userWithFamily'

export const USER_QUERY = gql`
  query User {
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
